export default {
  "mainVegetable": "povrce",
  "mainVegetable/01": "povrce/patlidzani",
  "mainVegetable/02": "povrce/sparoge",
  "mainVegetable/03": "povrce/avokado",
  "mainVegetable/04": "povrce/repa",
  "mainVegetable/05": "povrce/brokula",
  "mainVegetable/06": "povrce/mrkva",
  "mainVegetable/07": "povrce/celer",
  "mainVegetable/08": "povrce/gljive",
  "mainVegetable/09": "povrce/kupus",
  "mainVegetable/10": "povrce/kupus-kelj",
  "mainVegetable/11": "povrce/kineski-kupus",
  "mainVegetable/12": "povrce/cvjetaca",
  "mainVegetable/13": "povrce/kupus-salata",
  "mainVegetable/14": "povrce/krastavac",
  "mainVegetable/15": "povrce/tikvica",
  "mainVegetable/16": "povrce/endivija",
  "mainVegetable/17": "povrce/spinat",
  "mainVegetable/18": "povrce/grah-bobica",
  "mainVegetable/19": "povrce/flazoleti",
  "mainVegetable/20": "povrce/pljosnati-grah",
  "mainVegetable/21": "povrce/suhi-grah",
  "mainVegetable/22": "povrce/zelena-mahuna",
  "mainVegetable/23": "povrce/lece",
  "mainVegetable/24": "povrce/makedonska-salata",
  "mainVegetable/25": "povrce/vise",
  "mainVegetable/26": "povrce/mjesavina-zelenih-salata",
  "mainVegetable/27": "povrce/repa",
  "mainVegetable/28": "povrce/luk",
  "mainVegetable/29": "povrce/grasak",
  "mainVegetable/30": "povrce/papricice",
  "mainVegetable/31": "povrce/krumpiri-i-krumpiri",
  "mainVegetable/32": "povrce/mladi-izdanci-soje",
  "mainVegetable/33": "povrce/rotkvice",
  "mainVegetable/34": "povrce/salata-od-hrastovog-lista",
  "mainVegetable/35": "povrce/salata-od-friza",
  "mainVegetable/36": "povrce/salata-iceberg",
  "mainVegetable/37": "povrce/pijemontska-salata",
  "mainVegetable/38": "povrce/riza-salata",
  "mainVegetable/39": "povrce/romanska-salata",
  "mainVegetable/40": "povrce/mladi-izdanci",
  "mainVegetable/41": "povrce/zelena-salata",
  "mainVegetable/42": "povrce/matovilac",
  "mainVegetable/43": "povrce/rukola",
  "mainVegetable/44": "povrce/sparoge",
  "mainVegetable/45": "povrce/tabule",
  "mainVegetable/46": "povrce/rajcice",
  "mainVegetable/47": "povrce/grah-sa-maslacem",
  "mainVegetable/48": "povrce/slanutak",
  "mainVegetable/49": "povrce/poriluk",
  "mainVegetable/50": "povrce/bundeva",
  "mainVegetable/51": "povrce/crveni-grah",
  "mainVegetable/52": "povrce/jabuke",
  "mainVegetable/53": "povrce/kesteni",
  "mainVegetable/54": "povrce/suhe-sljive",
  "mainVegetable/55": "povrce/vrtlar",
  "mainVegetable/56": "povrce/crne-masline",
  "mainVegetable/57": "povrce/articoke",
  "mainVegetable/58": "povrce/crvene-paprike",
  "mainVegetable/59": "povrce/ravni-zeleni-grah",
  "mainVegetable/60": "povrce/proljece",
  "mainVegetable/61": "povrce/ratatouille",
  "mainVegetable/62": "povrce/kuskus",
  "mainVegetable/63": "povrce/tazin",
  "mainVegetable/64": "povrce/kari-od-povrca",
  "mainVegetable/65": "povrce/casice-od-graska",
  "mainVegetable/66": "povrce",
  "mainVegetable/67": "povrce/koralna-leca",
  "mainVegetable/68": "povrce/kvinoja",
  "mainVegetable/69": "povrce/spelta",
  "mainVegetable/70": "povrce/bulgur",
  "mainVegetable/71": "povrce/crveni-kupus",
  "mainVegetable/72": "povrce/kelj",
  "mainVegetable/73": "povrce/materina-dusica",
  "mainVegetable/74": "povrce/zitarice-i-sjemenke",
  "mainVegetable/75": "povrce/mahunarke",
  "mainVegetable/76": "povrce/slatki-krumpir",
  "mainVegetable/77": "povrce/bundeve",
  "mainVegetable/78": "povrce/tijesto",
  "mainVegetable/79": "povrce/grah",
  "mainVegetable/80": "povrce/grah--mrkva",
  "mainVegetable/81": "povrce/grah",
  "mainVegetable/82": "povrce/edamame",
  "mainVegetable/83": "povrce/jecam",
  "mainVegetable/84": "povrce/salata-miks",
  "mainVegetable/85": "povrce/secernica-cicoka",
  "mainVegetable/86": "povrce/janjeca-salata",
  "mainVegetable/87": "povrce/bebi-spinat",
  "mainVegetable/88": "povrce/bebi-zelena-batavia",
  "mainVegetable/89": "povrce/blitva",
  "mainVegetable/90": "povrce/mrkva",
  "mainVegetable/91": "povrce/crna-venerina-riza",
  "mainVegetable/92": "povrce/mjesavina-graha",
  "mainVegetable/93": "povrce/crni-grah",
  "mainVegetable/94": "povrce/glavica-kupusa",
  "mainVegetable/95": "povrce/bijeli-grah",
  "mainVegetable/96": "povrce/suseni-rajcici",
  "mainVegetable/97": "povrce/mjesavina-povrca",
  "mainVegetable/98": "povrce/puter-od-oraha",
  "productRange": "rasponi",
  "productRange/4G_BIO": "rasponi",
  "productRange/4G_SRP": "rasponi",
  "productRange/CAN_A_POEL": "rasponi",
  "productRange/CAN_SEC_BI": "rasponi",
  "productRange/CAN_SEC_CO": "rasponi",
  "productRange/CAN_SEC_CU": "rasponi",
  "productRange/CAN_SEC_NA": "rasponi",
  "productRange/CAN_VAPEUR": "rasponi",
  "productRange/CAN_VEG_SA": "rasponi",
  "productRange/CAN_VEG_SR": "rasponi",
  "productRange/CLASSICVEG": "rasponi",
  "productRange/COLDVEGE": "rasponi",
  "productRange/COOKMUSH": "rasponi",
  "productRange/CRUDITES": "rasponi",
  "productRange/DE_NOS_PRO": "rasponi",
  "productRange/DOYMUSHACC": "rasponi",
  "productRange/DOYMUSHAPE": "rasponi",
  "productRange/DRYVEGE": "rasponi",
  "productRange/FROZENVEGE": "rasponi",
  "productRange/FRZ_ASTUCE": "rasponi",
  "productRange/FRZ_GRATIN": "rasponi",
  "productRange/FRZ_KELLO": "rasponi",
  "productRange/FRZ_LEG_CO": "rasponi",
  "productRange/FRZ_PUREES": "rasponi",
  "productRange/FRZ_VEG_BI": "rasponi",
  "productRange/FRZ_VEG_SR": "rasponi",
  "productRange/INDFROZVEG": "rasponi",
  "productRange/JEUNES_POU": "rasponi",
  "productRange/LAITUES": "rasponi",
  "productRange/LOOP": "rasponi",
  "productRange/LUNCH_BOWL": "rasponi",
  "productRange/MACHE_BASE": "rasponi",
  "productRange/MEL_LAITUE": "rasponi",
  "productRange/MUSHNATEMI": "rasponi",
  "productRange/MUSHNATENT": "rasponi",
  "productRange/MUSHNATEPA": "rasponi",
  "productRange/MUSHNATMIN": "rasponi",
  "productRange/MUSHROOMS": "rasponi",
  "productRange/SUNVEGE": "rasponi",
  "productRange/TRAIT_CRUD": "rasponi",
  "productRange/TRAIT_TABO": "rasponi",
  "productRange/TUS_RECETA": "rasponi",
  "productRange/WORLDVEGE": "rasponi",
  "productRange/PREPARED_VEG": "rasponi",
  "productRange/BEAN_SAUCE": "rasponi/grah-u-umaku",
  "productRange/BEANS": "rasponi/grah",
  "productRange/BIO": "rasponi/bio",
  "productRange/BOND_KIDS": "rasponi/bonduelle-djeca",
  "productRange/CAN_BIO": "rasponi/bio-povrce​",
  "productRange/CAN_SEC_PR": "rasponi",
  "productRange/CARTA_DELL": "rasponi/jelovnik-salata",
  "productRange/CAN_PETITS": "rasponi",
  "productRange/CAN_BOCAL": "rasponi",
  "productRange/CEREAL_CAN": "rasponi/zitarice-ambijent",
  "productRange/CEREAL_FRZ": "rasponi/zitarice-smrznute",
  "productRange/CEREALI": "rasponi/zitarice",
  "productRange/CEREALLEGR": "rasponi/zitarica",
  "productRange/COCCOLE": "rasponi/coccole",
  "productRange/CORN": "rasponi/kukuruz",
  "productRange/CREATIF": "rasponi/kreativno",
  "productRange/FRANCAIS": "rasponi/100-francuski",
  "productRange/FRZ_FRY_MI": "rasponi",
  "productRange/FRZ_MELANG": "rasponi/mjesavine-povrca​",
  "productRange/FRZ_POELEE": "rasponi/smrznute-pripremljene-mjesavine",
  "productRange/INSALATE_D": "rasponi/poljoprivredna-salata",
  "productRange/INSALATONA": "rasponi/salata-jos",
  "productRange/LE_REGIONA": "rasponi/regionalne",
  "productRange/LEGUMIO": "rasponi/legumio",
  "productRange/MIXES_CORN": "rasponi/mijesa-se-s-kukuruzom",
  "productRange/MONO_VEGE": "rasponi/mono-povrce",
  "productRange/MUSHROOMS  ": "rasponi/gljiva",
  "productRange/NATURA_IN": "rasponi/priroda-u-tavi",
  "productRange/OTHER_VEG": "rasponi/drugo-povrce",
  "productRange/PEAS": "rasponi/grah",
  "productRange/READY_FROZ": "rasponi/spremni-smrznuti-obroci",
  "productRange/SOUPS": "rasponi/povrce-za-juhe",
  "productRange/SPINACH": "rasponi/spinat",
  "productRange/STEAM_CAN": "rasponi/para-konzerva",
  "productRange/STEAM_FRZ": "rasponi/para-smrznuto",
  "productRange/STEAM_MIX": "rasponi/para-zamrznuto-povrce",
  "productRange/STUZZICHIA": "rasponi/stuzzichiamo",
  "productRange/TOUCHE": "rasponi/obogacivac",
  "productRange/TRAIT_SAL": "rasponi/povrce-za-​​salatu​",
  "productRange/TUS_RECETA ": "rasponi/vasi-recepti",
  "productRange/VEG_TO_FRY": "rasponi/povrce-za-przenje",
  "productRange/VEGGIE": "rasponi/povrce-i-riza",
  "productRange/FRZ_JUSTEA": "rasponi/zamrznuto-jednovrsno-povrce",
  "productRange/SALABIS": "rasponi",
  "productRange/BON_SENGAG": "rasponi",
  "productRange/CROUSTIS": "rasponi",
  "season": "sezone",
  "season/1": "sezone/ljeto",
  "season/2": "sezone/jesen",
  "season/3": "sezone/zimsko-vrijeme",
  "season/4": "sezone/proljece",
  "season/5": "sezone",
  "technologie": "tehnologija",
  "technologie/AC01": "tehnologija/sacuvati",
  "technologie/AD01": "tehnologija/zaledjeno",
  "technologie/AG01": "tehnologija/svjeze",
  "technologie/AT01": "tehnologija/ugostitelj",
  "recipeDish": "vrsta-tanjura",
  "recipeDish/ACC": "vrsta-tanjura/pratnja",
  "recipeDish/APE": "vrsta-tanjura/aperitiv",
  "recipeDish/DES": "vrsta-tanjura/desert",
  "recipeDish/ENT": "vrsta-tanjura/ulaz",
  "recipeDish/PLAT": "vrsta-tanjura/jelo",
  "recipeDish/SAL": "vrsta-tanjura/salata",
  "recipeDish/SNA": "vrsta-tanjura/grickalice-bar",
  "recipeDish/PDE": "vrsta-tanjura/dorucak",
  "recipeDish/DEJ": "vrsta-tanjura/rucak",
  "recipeDish/TRA": "vrsta-tanjura/tradicionalno",
  "recipeDish/GOU": "vrsta-tanjura/gurmanska-hrana",
  "recipeDish/ETH": "vrsta-tanjura/etnicka-pripadnost",
  "recipeDish/FCH": "vrsta-tanjura/za-djecu",
  "recipeDish/SOU": "vrsta-tanjura/juha",
  "pred-recipeTimingCook-facet": "pecenje",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "pecenje/0-15-minuta",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "pecenje/15-30-minuta",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "pecenje/30-45-minuta",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "pecenje/45-minuta",
  "pred-recipeTimingPreparation-facet": "priprema",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "priprema/0-15-minuta",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "priprema/15-30-minuta",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "priprema/30-45-minuta",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "priprema/45-minuta",
  "pred-recipeCost-Facet": "budzet",
  "pred-recipeCost-Facet/petit": "budzet/jeftino",
  "pred-recipeCost-Facet/moyen": "budzet/srednje",
  "pred-recipeCost-Facet/grand": "budzet/visoko",
  "recipeDifficulty": "priprema",
  "recipeDifficulty/1": "priprema/lako",
  "recipeDifficulty/2": "priprema/srednje",
  "recipeDifficulty/3": "priprema/pojasnjenje",
  "recipeDishNumber": "gosti",
  "recipeDishNumber/1": "gosti/1",
  "recipeDishNumber/2": "gosti/2",
  "recipeDishNumber/3": "gosti/3",
  "recipeDishNumber/4": "gosti/4",
  "recipeDishNumber/5": "gosti/5",
  "recipeDishNumber/6": "gosti/6",
  "recipeDishNumber/7": "gosti/7",
  "recipeDishNumber/8": "gosti/8",
  "productTheme": "proizvodi-po-temi",
  "productTheme/ACC": "proizvodi-po-temi/pratnja",
  "productTheme/BEA": "proizvodi-po-temi/grah",
  "productTheme/BIS": "proizvodi-po-temi/grah-u-umaku",
  "productTheme/BIO": "proizvodi-po-temi/bio",
  "productTheme/CAN": "proizvodi-po-temi/konzervirana-hrana",
  "productTheme/CER": "proizvodi-po-temi/zitarice",
  "productTheme/CLS": "proizvodi-po-temi/klasici",
  "productTheme/DLE": "proizvodi-po-temi/povrce",
  "productTheme/EDR": "proizvodi-po-temi/obogacivaci-jela",
  "productTheme/ENT": "proizvodi-po-temi/predjela",
  "productTheme/FRZ": "proizvodi-po-temi/svjeze-smrznuto",
  "productTheme/FSD": "proizvodi-po-temi/za-salate",
  "productTheme/FSH": "proizvodi-po-temi/naknade",
  "productTheme/ING": "proizvodi-po-temi/sastojci-za-moje-recepte",
  "productTheme/JAR": "proizvodi-po-temi/povrce-u-staklenki",
  "productTheme/LBW": "proizvodi-po-temi/posuda-za-rucak",
  "productTheme/LDF": "proizvodi-po-temi/povrce-u-pecnici",
  "productTheme/LEG": "proizvodi-po-temi/mahunarke",
  "productTheme/LGO": "proizvodi-po-temi/legumio",
  "productTheme/LGR": "proizvodi-po-temi/grilovano-povrce",
  "productTheme/LGS": "proizvodi-po-temi/povrce-za-juhu",
  "productTheme/MAI": "proizvodi-po-temi/ono-ali",
  "productTheme/MUS": "proizvodi-po-temi/gljive",
  "productTheme/NEW": "proizvodi-po-temi/novi-proizvodi",
  "productTheme/PDH": "proizvodi-po-temi/suho-povrce-kuhinjska-jela",
  "productTheme/PDL": "proizvodi-po-temi/kosara-povrca",
  "productTheme/PHR": "proizvodi-po-temi/tjestenina-i-tjestenina",
  "productTheme/PLP": "proizvodi-po-temi/glavno-jelo",
  "productTheme/RAL": "proizvodi-po-temi/riza-povrce",
  "productTheme/RDM": "proizvodi-po-temi/kuhinjski-tanjuri",
  "productTheme/SAL": "proizvodi-po-temi/sve-za-moje-place",
  "productTheme/SDB": "proizvodi-po-temi/salata-zdjela",
  "productTheme/SNK": "proizvodi-po-temi/grickanje",
  "productTheme/SUP": "proizvodi-po-temi/juha",
  "productTheme/TEX": "proizvodi-po-temi/teks-meks",
  "productTheme/VGP": "proizvodi-po-temi/biljne-bjelancevine",
  "recipeTheme": "recepti-prema-temi",
  "recipeTheme/01": "recepti-prema-temi/blagdanski-recepti",
  "recipeTheme/02": "recepti-prema-temi/aperitiv",
  "recipeTheme/03": "recepti-prema-temi/salate-i-umaci",
  "recipeTheme/04": "recepti-prema-temi/juhe-i-gazpachos",
  "recipeTheme/05": "recepti-prema-temi/quiche-torta-i-gratinirane-posude",
  "recipeTheme/06": "recepti-prema-temi/specijal-djeca",
  "recipeTheme/07": "recepti-prema-temi/deserti",
  "recipeTheme/08": "recepti-prema-temi/vegetarijanci",
  "recipeTheme/09": "recepti-prema-temi/pratitelji",
  "recipeTheme/10": "recepti-prema-temi/dolazi-izdaleka",
  "recipeTheme/11": "recepti-prema-temi/mijotes",
  "recipeTheme/12": "recepti-prema-temi/salate-i-rostilj",
  "recipeTheme/13": "recepti-prema-temi/grickalice-i-hrana-koja-se-jede-prstima",
  "recipeTheme/14": "recepti-prema-temi/glavno-jelo",
  "recipeTheme/15": "recepti-prema-temi/deserti-i-peciva",
  "recipeTheme/16": "recepti-prema-temi/predjela-i-juhe",
  "recipeTheme/17": "recepti-prema-temi/salate",
  "recipeTheme/18": "recepti-prema-temi/posude",
  "recipeTheme/19": "recepti-prema-temi/juhe",
  "recipeTheme/20": "recepti-prema-temi/grickalice",
  "recipeTheme/21": "recepti-prema-temi/umak",
  "recipeTheme/22": "recepti-prema-temi/pojedinacna-jela",
  "recipeTheme/23": "recepti-prema-temi/ostala-jela",
  "recipeTheme/24": "recepti-prema-temi/pecena-jela",
  "recipeTheme/25": "recepti-prema-temi/meksicki",
  "recipeTheme/26": "recepti-prema-temi/oko-svijeta",
  "recipeTheme/27": "recepti-prema-temi/dan-bez-mesa",
  "recipeTheme/28": "recepti-prema-temi/niska-razina-ugljikohidrata",
  "recipeTheme/33": "recepti-prema-temi/baza-od-leca",
  "recipeTheme/34": "recepti-prema-temi/baza-od-cvjetace",
  "recipeTheme/35": "recepti-prema-temi/baza-od-krumpira",
  "recipeTheme/36": "recepti-prema-temi/baza-od-mrkve",
  "recipeTheme/37": "recepti-prema-temi/baza-od-spinata",
  "recipeTheme/38": "recepti-prema-temi/baza-od-paprika",
  "recipeTheme/39": "recepti-prema-temi/baza-od-gljiva",
  "recipeTheme/40": "recepti-prema-temi/baza-od-ravne-zelene-mahune",
  "recipeTheme/41": "recepti-prema-temi/baza-od-kukuruza",
  "recipeTheme/42": "recepti-prema-temi/baza-od-graha",
  "recipeTheme/43": "recepti-prema-temi/baza-od-crvenog-graha",
  "recipeTheme/44": "recepti-prema-temi/flazolet-baza",
  "recipeTheme/45": "recepti-prema-temi/baza-od-slanutka",
  "recipeTheme/46": "recepti-prema-temi/baza-od-brokule",
  "pred-particularite": "prehrambene-navike",
  "pred-particularite/Sans%20conservateur": "prehrambene-navike/bez-konzervansa",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "prehrambene-navike",
  "pred-particularite/Sans%20colorant": "prehrambene-navike/bez-boja",
  "pred-particularite/Sans%20sucre%20ajout%E9": "prehrambene-navike/bez-dodanog-secera",
  "pred-particularite/Sans%20sel%20ajout%E9": "prehrambene-navike/bez-dodane-soli",
  "pred-particularite/Sans%20additif": "prehrambene-navike/bez-aditiva",
  "pred-particularite/": "prehrambene-navike/prirodno-nastala-sol",
  "pred-particularite/Sans%20lactose": "prehrambene-navike/bez-laktoze",
  "pred-particularite/Sans%20gluten": "prehrambene-navike/bez-glutena",
  "pred-particularite/V%E9g%E9tarien": "prehrambene-navike/vege",
  "pred-particularite/V%E9g%E9talien": "prehrambene-navike/vegansko",
  "pred-particularite/Sans%20sulfite": "prehrambene-navike/bez-sumpora",
  "pred-particularite/A%20la%20vapeur": "prehrambene-navike/para",
  "pred-particularite/Sans%20condiment": "prehrambene-navike/bez-zacina",
  "cultureType": "vrsta-kulture",
  "cultureType/Bio": "vrsta-kulture/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "vrsta-kulture/bez-ostataka-pesticida",
  "cultureType/Sans%20OGM": "vrsta-kulture/bez-gmo-a",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "prehrambene-navike/vegansko",
  "pred-particularite/recipeVeggie": "prehrambene-navike/vege",
  "pred-particularite/recipeGlutenfree": "prehrambene-navike/bez-glutena",
  "pred-particularite/recipeLactosefree": "prehrambene-navike/bez-laktoze",
  "cultureOrigin": "porijeklo-kulture",
  "cultureOrigin/31": "porijeklo-kulture/azerbejdzan",
  "cultureOrigin/32": "porijeklo-kulture/argentina",
  "cultureOrigin/36": "porijeklo-kulture/australija",
  "cultureOrigin/40": "porijeklo-kulture/austrija",
  "cultureOrigin/51": "porijeklo-kulture/armenija",
  "cultureOrigin/56": "porijeklo-kulture/belgija",
  "cultureOrigin/68": "porijeklo-kulture/bolivija",
  "cultureOrigin/70": "porijeklo-kulture/bosna-i-hercegovina",
  "cultureOrigin/76": "porijeklo-kulture/brazil",
  "cultureOrigin/97": "porijeklo-kulture/europska-unija",
  "cultureOrigin/100": "porijeklo-kulture/bugarska",
  "cultureOrigin/104": "porijeklo-kulture/burma",
  "cultureOrigin/120": "porijeklo-kulture/kamerun",
  "cultureOrigin/124": "porijeklo-kulture/kanada",
  "cultureOrigin/152": "porijeklo-kulture/cile",
  "cultureOrigin/156": "porijeklo-kulture/kina",
  "cultureOrigin/188": "porijeklo-kulture/kostarika",
  "cultureOrigin/191": "porijeklo-kulture/hrvatska",
  "cultureOrigin/196": "porijeklo-kulture/cipar",
  "cultureOrigin/203": "porijeklo-kulture/ceska-republika",
  "cultureOrigin/208": "porijeklo-kulture/danska",
  "cultureOrigin/231": "porijeklo-kulture/etiopija",
  "cultureOrigin/233": "porijeklo-kulture/estonija",
  "cultureOrigin/246": "porijeklo-kulture/finska",
  "cultureOrigin/250": "porijeklo-kulture/francuska",
  "cultureOrigin/258": "porijeklo-kulture/francuska-polinezija",
  "cultureOrigin/276": "porijeklo-kulture/njemacka",
  "cultureOrigin/300": "porijeklo-kulture/grcka",
  "cultureOrigin/320": "porijeklo-kulture/gvatemala",
  "cultureOrigin/344": "porijeklo-kulture/hong-kong",
  "cultureOrigin/348": "porijeklo-kulture/madjarska",
  "cultureOrigin/352": "porijeklo-kulture/island",
  "cultureOrigin/356": "porijeklo-kulture/antili",
  "cultureOrigin/360": "porijeklo-kulture/indonezija",
  "cultureOrigin/372": "porijeklo-kulture/irska",
  "cultureOrigin/376": "porijeklo-kulture/izrael",
  "cultureOrigin/380": "porijeklo-kulture/italija",
  "cultureOrigin/398": "porijeklo-kulture/kazahstan",
  "cultureOrigin/404": "porijeklo-kulture/kenija",
  "cultureOrigin/414": "porijeklo-kulture/kuvajt",
  "cultureOrigin/417": "porijeklo-kulture/kirgistan",
  "cultureOrigin/422": "porijeklo-kulture/libanon",
  "cultureOrigin/428": "porijeklo-kulture/latvija",
  "cultureOrigin/440": "porijeklo-kulture/litva",
  "cultureOrigin/442": "porijeklo-kulture/luksemburg",
  "cultureOrigin/450": "porijeklo-kulture/madagaskar",
  "cultureOrigin/470": "porijeklo-kulture/malta",
  "cultureOrigin/480": "porijeklo-kulture/mauricijus",
  "cultureOrigin/484": "porijeklo-kulture/meksiko",
  "cultureOrigin/498": "porijeklo-kulture/moldova",
  "cultureOrigin/499": "porijeklo-kulture/crna-gora",
  "cultureOrigin/504": "porijeklo-kulture/maroko",
  "cultureOrigin/528": "porijeklo-kulture/nizozemska",
  "cultureOrigin/548": "porijeklo-kulture/vanuatu",
  "cultureOrigin/578": "porijeklo-kulture/norveska",
  "cultureOrigin/586": "porijeklo-kulture/pakistan",
  "cultureOrigin/604": "porijeklo-kulture/peru",
  "cultureOrigin/616": "porijeklo-kulture/poljska",
  "cultureOrigin/620": "porijeklo-kulture/portugal",
  "cultureOrigin/634": "porijeklo-kulture/katar",
  "cultureOrigin/642": "porijeklo-kulture/rumunjska",
  "cultureOrigin/643": "porijeklo-kulture/rusija",
  "cultureOrigin/703": "porijeklo-kulture/slovacka",
  "cultureOrigin/704": "porijeklo-kulture/vijetnam",
  "cultureOrigin/705": "porijeklo-kulture/slovenija",
  "cultureOrigin/724": "porijeklo-kulture/spanjolska",
  "cultureOrigin/752": "porijeklo-kulture/svedska",
  "cultureOrigin/756": "porijeklo-kulture/svicarska",
  "cultureOrigin/764": "porijeklo-kulture/tajland",
  "cultureOrigin/784": "porijeklo-kulture/ujedinjeni-arapski-emirati",
  "cultureOrigin/792": "porijeklo-kulture/turska",
  "cultureOrigin/795": "porijeklo-kulture/turkmenistan",
  "cultureOrigin/804": "porijeklo-kulture/ukrajina",
  "cultureOrigin/818": "porijeklo-kulture/egipat",
  "cultureOrigin/826": "porijeklo-kulture/ujedinjeno-kraljevstvo",
  "cultureOrigin/834": "porijeklo-kulture/tanzanija",
  "cultureOrigin/840": "porijeklo-kulture/sjedinjene-drzave",
  "cultureOrigin/999": "porijeklo-kulture/izvoz",
  "cultureOrigin/NON_EU": "porijeklo-kulture/van-eu",
  "cultureOrigin/UE": "porijeklo-kulture/eu",
  "cultureOrigin/XXX": "porijeklo-kulture/prazno"
};
